import { render, staticRenderFns } from "./PointNav.vue?vue&type=template&id=f036b78e&"
import script from "./PointNav.vue?vue&type=script&lang=js&"
export * from "./PointNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports